import React, { useEffect } from "react";
import classes from "./profilebar.module.scss";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useSearchParams } from "react-router-dom";
import { MdFavoriteBorder, MdOutlineRateReview } from "react-icons/md";
import { CiUser } from "react-icons/ci";
import { FaBlog } from "react-icons/fa6";

const ProfileBar = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "Wishlist" });
    }
  }, []);

  return (
    <div className={classes.profileBar}>
      <ul>
        {/* <li className={searchParams.get("tab") === "My Feed" ? classes.selected : classes.Unselected} onClick={() => { setSearchParams({ tab: "My Feed" }) }}>My Feed</li> */}
        <li
          className={
            searchParams.get("tab") === "Wishlist"
              ? classes.selected
              : classes.Unselected
          }
          onClick={() => {
            setSearchParams({ tab: "Wishlist" });
          }}
        >
          <MdFavoriteBorder style={{ fontSize: "1.7rem", color: "#F46444" }} />
          {/* <FavoriteIcon sx={{ fontSize: "1.7rem", color: "#F46444" }} /> */}
          Wishlist
        </li>
        <li
          className={
            searchParams.get("tab") === "Profile Info"
              ? classes.selected
              : classes.Unselected
          }
          onClick={() => {
            setSearchParams({ tab: "Profile Info" });
          }}
        >
          <CiUser style={{ fontSize: "1.7rem", color: "#F46444" }} />
          Profile Info
        </li>
        <li
          className={
            searchParams.get("tab") === "Reviews"
              ? classes.selected
              : classes.Unselected
          }
          onClick={() => {
            setSearchParams({ tab: "Reviews" });
          }}
        >
          <MdOutlineRateReview
            style={{ fontSize: "1.7rem", color: "#F46444" }}
          />
          Reviews
        </li>
        <li
          className={
            searchParams.get("tab") === "Blog"
              ? classes.selected
              : classes.Unselected
          }
          onClick={() => {
            setSearchParams({ tab: "Blog" });
          }}
        >
          <FaBlog style={{ fontSize: "1.7rem", color: "#F46444" }} />
          Blog
        </li>
      </ul>
    </div>
  );
};

export default ProfileBar;
